export default __webpack_public_path__ + "assets/jamespot-blue-2025-216.cbe9350502876bd1e0495637f73b0ce6.png";